export interface HttpClientConfig {
	timeoutSeconds: number;
}

export const DEFAULT_HTTP_CLIENT_TIMEOUT_SECONDS = 20;

let config: HttpClientConfig | undefined;

export function getHttpClientConfig(): HttpClientConfig {
	if (config === undefined) {
		config = { timeoutSeconds: getTimeoutSeconds(readEnvValue()) };
	}
	return config;
}

export function loadHttpClientConfig(
	rawTimeoutSeconds: string | undefined
): HttpClientConfig {
	config = { timeoutSeconds: getTimeoutSeconds(rawTimeoutSeconds) };
	return config;
}

function readEnvValue(): string | undefined {
	if (typeof process === "undefined" || process.env === undefined) {
		return undefined;
	}
	return process.env.HTTP_CLIENT_TIMEOUT_SECONDS;
}

function getTimeoutSeconds(raw: string | undefined): number {
	if (raw === undefined || raw === null) {
		return DEFAULT_HTTP_CLIENT_TIMEOUT_SECONDS;
	}
	const parsed = Number(raw);
	return !Number.isFinite(parsed) || parsed <= 0
		? DEFAULT_HTTP_CLIENT_TIMEOUT_SECONDS
		: parsed;
}
